var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[(this.$route.params.uname)?_c('login-cool'):[_c('header-cool'),_c('body-cool'),_c('footer-cool')]],2)}
var staticRenderFns = []

export { render, staticRenderFns }